<section class="">
    <div class="flex flex-col items-center justify-center">
        <img src="/assets/images/success-badge.svg" alt="Success Badge" class="w-16 h-16 mb-4" />
        <h2 class="text-xl font-bold text-font-primary">Your review has been submitted!</h2>
        <p class="mb-4 mt-1 text-xs text-font-secondary">
            Your review has been submitted successfully. You can view the status of your review on the dashboard.
        </p>
    </div>
    <div class="flex w-full items-center justify-center">
        <sag-ui-button size="sm" (click)="backToDashboard()">Back to Dashboard</sag-ui-button>
    </div>
</section>
